import { render, staticRenderFns } from "./CreateSlideForm.vue?vue&type=template&id=70fa720c&scoped=true&"
import script from "./CreateSlideForm.vue?vue&type=script&lang=js&"
export * from "./CreateSlideForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateSlideForm.vue?vue&type=style&index=0&id=70fa720c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa720c",
  null
  
)

export default component.exports